import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './ToolTip.module.css'
import styleNames from '../../utils/styleNames'

export default class ToolTip extends Component {
  static propTypes = {
    title: PropTypes.string,
    isVisible: PropTypes.bool,
  }
  constructor (props) {
    super(props)
  }
  render () {
    return (
      <div className={styleNames(styles, `wrapper ${this.props.isVisible ? 'isVisible' : ''}`)} dangerouslySetInnerHTML={{ __html: this.props.title }} />
    )
  }
}

